import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private commonApiService: CommonApiService) {}

  onLoginWithMagicLink(payload: any) {
    return this.commonApiService.post(APIURL.loginWithMagicLink, payload);
  }

  onVerifyMagicLink(payload: any) {
    return this.commonApiService.post(APIURL.verifyMagicLink, payload);
  }

  // login(payload: any) {
  //   return this.commonApiService.post(APIURL.userLogin, payload);
  // }

  // loginUserOTPVerification(payload: any) {
  //   return this.commonApiService.post(APIURL.verifyLoginOTP, payload);
  // }

  preCheckUser(payload: any) {
    return this.commonApiService.post(APIURL.preCheckUser, payload);
  }

  onUserRegistrationVerifyOTPAndUserSignup(formData: FormData) {
    return this.commonApiService.post(
      APIURL.userRegistrationVerifyOTPAndUserSignup,
      formData,
    );
  }

  // onCompanyDetailsSubmission(payload: any) {
  //   return this.commonApiService.post(
  //     APIURL.UserRegistrationCompanyDetails,
  //     payload
  //   );
  // }

  onUserOnboarding(payload: any) {
    return this.commonApiService.post(APIURL.UserOnboarding, payload);
  }

  getInviteDetails(invitationLink: string) {
    return this.commonApiService.get(APIURL.getInviteDetails + "/" + invitationLink);
  }

  acceptInvite(payload: any) {
    return this.commonApiService.post(APIURL.acceptInvite, payload);
  }

  declineInvite(payload: any) {
    return this.commonApiService.post(APIURL.declineInvite, payload);
  }

  resendInvitationByEmail(payload: any) {
    return this.commonApiService.post(APIURL.resendInvitationByEmail, payload);
  }
}
